// removed by extract-text-webpack-plugin
module.exports = {"loadingSpinner":"_1M3L-"};